export default "__VITE_ASSET__D$mtO4JN__"